export default __webpack_public_path__ + "static/GothamNarrowBoldItalic-995fc7995a3f33eeb0a29c866ab1aca1.otf";